module.exports = __webpack_public_path__ + "a8bd377a3629a039189c1e08295883a3.jpg";